// extracted by mini-css-extract-plugin
export default {"button":"Password_button__E94b3","buttons":"Password_buttons__eNnNn"};